import type { GettextInterface } from "../I18n";

import { REPORT_JOB_FEEDBACK_MAX_LENGTH } from "../util/reportContent/ContentProblem";
import { canSubmitReportJob, getReportJobOptions } from "../util/reportContent/getReportJobOptions";

import { useCallback, useMemo, useState } from "react";

/**
 * Shared report-job form state (reasons, moreInfo, canSubmit). Surfaces supply their own submit.
 */
export function useReportJobFormState(
  gt: GettextInterface,
  showPhotoLabel = false,
  moreInfoMaxLength = REPORT_JOB_FEEDBACK_MAX_LENGTH,
  showNotHiringReason = false,
) {
  const [reason, setReason] = useState("");
  const [moreInfo, setMoreInfo] = useState("");

  const reportOptions = useMemo(
    () =>
      getReportJobOptions(gt, showPhotoLabel, showNotHiringReason).map((option) => ({
        value: option.value.toString(),
        label: option.label,
      })),
    [gt, showPhotoLabel, showNotHiringReason],
  );

  const selectedOption = useMemo(
    () => reportOptions.find((item) => item.value === reason) ?? null,
    [reportOptions, reason],
  );

  const selectReason = useCallback((value: string) => {
    setReason(value);
  }, []);

  const canSubmit = canSubmitReportJob({
    reason,
    moreInfo,
    feedbackMaxLength: moreInfoMaxLength,
  });

  const reset = useCallback(() => {
    setReason("");
    setMoreInfo("");
  }, []);

  return {
    reportOptions,
    selectedOption,
    reason,
    moreInfo,
    setMoreInfo,
    selectReason,
    canSubmit,
    reset,
  };
}
